import { respondTo } from 'assets/styled/breakpoints';
import styled, { css } from 'styled-components';
import {
  headerHeight,
  subHeaderHeight,
  subHeaderHeightMidTablet,
  subHeaderHeightSmallPhone,
  subHeaderHeightSmallPhoneExternal,
} from 'assets/styled';

interface LayoutColumnProps {
  isHeaderExpanded: boolean;
  isExternal: boolean;
}

// Publishes the fixed header's height to everything below it, so content that
// has to clear the header (the spacer here, sticky elements further down) reads
// one value instead of re-deriving this cascade. It is built from the same
// height tokens SubHeaderContainer uses, per breakpoint, so the two cannot drift.
export const LayoutColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;

  --app-header-height: ${headerHeight};
  ${(props: LayoutColumnProps) =>
    props.isHeaderExpanded &&
    css`
      --app-header-height: calc(${headerHeight} + ${subHeaderHeight});

      ${respondTo.midTablet`
        --app-header-height: calc(${headerHeight} + ${subHeaderHeightMidTablet});
      `}

      ${respondTo.smallPhone`
        --app-header-height: calc(${headerHeight} + ${
        props.isExternal
          ? subHeaderHeightSmallPhoneExternal
          : subHeaderHeightSmallPhone
      });
      `}
    `}
`;

export const LayoutRow = styled.div`
  display: flex;
  width: 100%;
`;

export const MarginTopHeaderHeight = styled.div`
  margin-top: var(--app-header-height, ${headerHeight});
`;
